import { DocumentCategory } from 'src/graphql/types/documents'

export const buildDocumentCategoryOptions = (
  formatter: (category: DocumentCategory) => string
) =>
  Object.values(DocumentCategory)
    .map((category) => ({
      value: category,
      label: formatter(category),
    }))
    .sort((a, b) => a.label.localeCompare(b.label))
